import { Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MaskType } from "src/app/constants/masks";

@Component({
    selector: 'mwp-verify-code',
    templateUrl: './verify-code.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class VerifyCodeComponent implements OnInit {
    @Input() public form: FormGroup;
    @Input() public nameForRadioControl: string;
    @Input() public useFixedWidth: boolean;

    public maskSingleNumeric = MaskType.singleNumeric;

    public input1: string = 'verifyInput1';
    public input2: string = 'verifyInput2';
    public input3: string = 'verifyInput3';
    public input4: string = 'verifyInput4';
    public input5: string = 'verifyInput5';
    public input6: string = 'verifyInput6';

    private currentCode: string;

    constructor(
    ){  
    }

    ngOnInit(): void {
        this.input1 = this.input1 + '_' + this.nameForRadioControl;
        this.input2 = this.input2 + '_' + this.nameForRadioControl;
        this.input3 = this.input3 + '_' + this.nameForRadioControl;
        this.input4 = this.input4 + '_' + this.nameForRadioControl;
        this.input5 = this.input5 + '_' + this.nameForRadioControl;
        this.input6 = this.input6 + '_' + this.nameForRadioControl;

        this.form.addControl(this.input1, new FormControl(null, [Validators.required, Validators.maxLength(1)]));
        this.form.addControl(this.input2, new FormControl(null, [Validators.required, Validators.maxLength(1)]));
        this.form.addControl(this.input3, new FormControl(null, [Validators.required, Validators.maxLength(1)]));
        this.form.addControl(this.input4, new FormControl(null, [Validators.required, Validators.maxLength(1)]));
        this.form.addControl(this.input5, new FormControl(null, [Validators.required, Validators.maxLength(1)]));
        this.form.addControl(this.input6, new FormControl(null, [Validators.required, Validators.maxLength(1)]));
    }

    public onKeyUpEvent(event: KeyboardEvent, controlName: string): void {
        let element;
        const l_ControlValue = this.form.get(controlName).value;
        if (l_ControlValue) {
            switch (controlName) {
                case this.input1:
                    element = this.input2;
                    break;

                case this.input2:
                    element = this.input3;
                    break;

                case this.input3:
                    element = this.input4;
                    break;

                case this.input4:
                    element = this.input5;
                    break;

                case this.input5:
                    element = this.input6;
                    break;
            }
        } else {
            if (event.code === 'Backspace') {
                switch (controlName) {
                    case this.input2:
                        element = this.input1;
                        break;

                    case this.input3:
                        element = this.input2;
                        break;

                    case this.input4:
                        element = this.input3;
                        break;

                    case this.input5:
                        element = this.input4;
                        break;

                    case this.input6:
                        element = this.input5;
                        break;
                }
            }
        }
        
        if (element)
            document.getElementById(element).focus();

        const l_ParentFormControl = this.form.get(this.nameForRadioControl);

        if (this.isValid()) {
            l_ParentFormControl.setValue(this.currentCode);
            document.getElementById(this.input6).focus();
        } else {
            l_ParentFormControl.setValue(null);
        }

        l_ParentFormControl.updateValueAndValidity();

        event.preventDefault();
    }

    public onPasteEvent(event: ClipboardEvent): void {
        const l_PasteData = event.clipboardData.getData('text');

        let l_PasteVerifiedData = l_PasteData.replace(/[^0-9]/g, '');

        if (l_PasteVerifiedData || l_PasteVerifiedData != '' ) {
            for (let i = 0; i < l_PasteVerifiedData.length; i++) {
                const radioControlName = `verifyInput${i + 1}_${this.nameForRadioControl}`; 
                this.form.get(radioControlName).setValue(l_PasteVerifiedData[i]);
                this.form.get(radioControlName).updateValueAndValidity();
            }
        } else {
            for (let i = 0; i < 6; i++) {
                const radioControlName = `verifyInput${i + 1}_${this.nameForRadioControl}`; 
                this.form.get(radioControlName).setValue(null);
                this.form.get(radioControlName).updateValueAndValidity();
            }
        }
    }

    private isValid(): boolean {
        const l_Input1 = this.form.get(this.input1).value;
        const l_Input2 = this.form.get(this.input2).value;
        const l_Input3 = this.form.get(this.input3).value;
        const l_Input4 = this.form.get(this.input4).value;
        const l_Input5 = this.form.get(this.input5).value;
        const l_Input6 = this.form.get(this.input6).value;

        this.currentCode = `${l_Input1}${l_Input2}${l_Input3}${l_Input4}${l_Input5}${l_Input6}`;

        if (l_Input1 && l_Input2 && l_Input3 && l_Input4 && l_Input5 && l_Input6)
            return true;

        return false;
    }

}